/* MODAL ACTIONS **************************************************************/

export const SHOW_MODAL = 'modal/SHOW_MODAL'
export const showModal = (component) => {
  return { type: SHOW_MODAL, component }
}

export const HIDE_MODAL = 'modal/HIDE_MODAL'
export const hideModal = () => { return { type: HIDE_MODAL } }

// deprecated?
export const LOCK = 'modal/LOCK'
export const lock = () => { return { type: LOCK } }

// deprecated?
export const UNLOCK = 'modal/UNLOCK'
export const unlock = () => { return { type: UNLOCK } }



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/modal.js